import axiosClient from '../axiosClient';

export const kpiApi = {
  getKPIMetrics: async (fromDate, toDate) => {
    try {
      const params = new URLSearchParams({
        fromDate: fromDate,
        toDate: toDate
      });

      console.log('📊 Fetching KPI metrics with params:', params.toString());

      const data = await axiosClient.get(`/kpi/metrics?${params.toString()}`);
      
      console.log('📊 KPI Metrics API data:', data);
      
      return data;
    } catch (error) {
      console.error('Error fetching KPI metrics:', error);
      throw error;
    }
  }
};